import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { AbstractControl, AsyncValidatorFn, FormControl, FormGroup, ValidatorFn } from '@angular/forms';
export class TagInputForm {
/**
 * \@name onSubmit
 */
public onSubmit: EventEmitter<any> = new EventEmitter();
/**
 * \@name onBlur
 */
public onBlur: EventEmitter<any> = new EventEmitter();
/**
 * \@name onFocus
 */
public onFocus: EventEmitter<any> = new EventEmitter();
/**
 * \@name onKeyup
 */
public onKeyup: EventEmitter<any> = new EventEmitter();
/**
 * \@name onKeydown
 */
public onKeydown: EventEmitter<any> = new EventEmitter();
/**
 * \@name placeholder
 */
public placeholder: string;
/**
 * \@name validators
 */
public validators: ValidatorFn[] = [];
/**
 * \@name asyncValidators
 * @desc array of AsyncValidator that are used to validate the tag before it gets appended to the list
 */
public asyncValidators: AsyncValidatorFn[] = [];
/**
 * \@name inputId
 */
public inputId: string;
/**
 * \@name inputClass
 */
public inputClass: string;
/**
 * \@name inputText
 * @return {?}
 */
public get inputText(): string {
        return this.inputTextValue;
    }
/**
 * \@name tabindex
 * @desc pass through the specified tabindex to the input
 */
public tabindex: string = '';
/**
 * \@name disabled
 */
public disabled: boolean = false;
/**
 * \@name inputText
 * @param {?} text {string}
 * @return {?}
 */
public set inputText(text: string) {
        this.inputTextValue = text;
        this.inputTextChange.emit(text);
    }
/**
 * \@name input
 */
public input;
/**
 * \@name form
 */
public form: FormGroup;
/**
 * \@name inputTextChange
 */
public inputTextChange: EventEmitter<string> = new EventEmitter();
/**
 * \@name inputTextValue
 */
public inputTextValue: string = '';
/**
 * @return {?}
 */
public ngOnInit() {
        // creating form
        this.form = new FormGroup({
            item: new FormControl({value: '', disabled: this.disabled}, this.validators, this.asyncValidators)
        });
    }
/**
 * \@name value
 * @return {?}
 */
public get value(): AbstractControl | null {
        return this.form.get('item');
    }
/**
 * \@name isInputFocused
 * @return {?}
 */
public isInputFocused(): boolean {
        return document.activeElement === this.input.nativeElement;
    }
/**
 * \@name getErrorMessages
 * @param {?} messages
 * @return {?}
 */
public getErrorMessages(messages): string[] {
        const /** @type {?} */ value = this.value;

        return value ? Object.keys(messages)
            .filter(err => value.hasError(err))
            .map(err => messages[err]) : [];
    }
/**
 * \@name hasErrors
 * @return {?}
 */
public hasErrors(): boolean {
        return this.form.dirty &&
            this.form.value.item &&
            this.form.invalid;
    }
/**
 * \@name focus
 * @return {?}
 */
public focus(): void {
        this.input.nativeElement.focus();
    }
/**
 * \@name blur
 * @return {?}
 */
public blur(): void {
        this.input.nativeElement.blur();
    }
/**
 * \@name getElementPosition
 * @return {?}
 */
public getElementPosition(): ClientRect {
        return this.input.nativeElement.getBoundingClientRect();
    }
/**
 * - removes input from the component
 * \@name destroy
 * @return {?}
 */
public destroy(): void {
        const /** @type {?} */ input = this.input.nativeElement;
        input.parentElement.removeChild(input);
    }
/**
 * \@name onKeyDown
 * @param {?} $event
 * @return {?}
 */
public onKeyDown($event) {
        return this.onKeydown.emit($event);
    }
/**
 * \@name submit
 * @param {?} $event
 * @return {?}
 */
public submit($event: any): void {
        this.onSubmit.emit($event);
    }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'tag-input-form',
    styles: [`
      .dark tag:focus {
        -webkit-box-shadow: 0 0 0 1px #323232;
                box-shadow: 0 0 0 1px #323232; }

      .ng2-tag-input.bootstrap3-info {
        background-color: #fff;
        display: inline-block;
        color: #555;
        vertical-align: middle;
        max-width: 100%;
        height: 42px;
        line-height: 44px; }

      .ng2-tag-input.bootstrap3-info input {
        border: none;
        -webkit-box-shadow: none;
                box-shadow: none;
        outline: none;
        background-color: transparent;
        padding: 0 6px;
        margin: 0;
        width: auto;
        max-width: inherit; }

      .ng2-tag-input.bootstrap3-info .form-control input::-moz-placeholder {
        color: #777;
        opacity: 1; }

      .ng2-tag-input.bootstrap3-info .form-control input:-ms-input-placeholder {
        color: #777; }

      .ng2-tag-input.bootstrap3-info .form-control input::-webkit-input-placeholder {
        color: #777; }

      .ng2-tag-input.bootstrap3-info input:focus {
        border: none;
        -webkit-box-shadow: none;
                box-shadow: none; }

      .bootstrap3-info.ng2-tag-input.ng2-tag-input--focused {
        -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.4);
                box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.4);
        border: 1px solid #ccc; }

      .bootstrap3-info.ng2-tag-input.ng2-tag-input--invalid {
        -webkit-box-shadow: inset 0 1px 1px #d9534f;
                box-shadow: inset 0 1px 1px #d9534f; }

      .ng2-tag-input {
        display: block;
        -webkit-box-orient: horizontal;
        -webkit-box-direction: normal;
            -ms-flex-direction: row;
                flex-direction: row;
        -ms-flex-wrap: wrap;
            flex-wrap: wrap;
        position: relative;
        -webkit-transition: all 0.25s;
        transition: all 0.25s;
        padding: 0.25rem 0;
        min-height: 32px;
        cursor: text;
        border-bottom: 2px solid #efefef; }
        .ng2-tag-input:focus {
          outline: 0; }
        .ng2-tag-input.ng2-tag-input--dropping {
          opacity: 0.7; }
        .ng2-tag-input.ng2-tag-input--focused {
          border-bottom: 2px solid #2196F3; }
        .ng2-tag-input.ng2-tag-input--invalid {
          border-bottom: 2px solid #f44336; }
        .ng2-tag-input.ng2-tag-input--loading {
          border: none; }
        .ng2-tag-input.ng2-tag-input--disabled {
          opacity: 0.5;
          cursor: not-allowed; }
        .ng2-tag-input form {
          margin: 0.1em 0; }
        .ng2-tag-input .ng2-tags-container {
          -ms-flex-wrap: wrap;
              flex-wrap: wrap;
          display: -webkit-box;
          display: -ms-flexbox;
          display: flex; }

      .minimal.ng2-tag-input {
        display: block;
        -webkit-box-orient: horizontal;
        -webkit-box-direction: normal;
            -ms-flex-direction: row;
                flex-direction: row;
        -ms-flex-wrap: wrap;
            flex-wrap: wrap;
        position: relative;
        cursor: text;
        border-bottom: 1px solid transparent; }
        .minimal.ng2-tag-input:focus {
          outline: 0; }
        .minimal.ng2-tag-input.ng2-tag-input--dropping {
          opacity: 0.7; }
        .minimal.ng2-tag-input.ng2-tag-input--loading {
          border: none; }
        .minimal.ng2-tag-input.ng2-tag-input--disabled {
          opacity: 0.5;
          cursor: not-allowed; }
        .minimal.ng2-tag-input .ng2-tags-container {
          -ms-flex-wrap: wrap;
              flex-wrap: wrap;
          display: -webkit-box;
          display: -ms-flexbox;
          display: flex; }

      .dark.ng2-tag-input {
        display: block;
        -webkit-box-orient: horizontal;
        -webkit-box-direction: normal;
            -ms-flex-direction: row;
                flex-direction: row;
        -ms-flex-wrap: wrap;
            flex-wrap: wrap;
        position: relative;
        cursor: text;
        border-bottom: 2px solid #444; }
        .dark.ng2-tag-input:focus {
          outline: 0; }
        .dark.ng2-tag-input.ng2-tag-input--dropping {
          opacity: 0.7; }
        .dark.ng2-tag-input.ng2-tag-input--loading {
          border: none; }
        .dark.ng2-tag-input.ng2-tag-input--disabled {
          opacity: 0.5;
          cursor: not-allowed; }
        .dark.ng2-tag-input .ng2-tags-container {
          -ms-flex-wrap: wrap;
              flex-wrap: wrap;
          display: -webkit-box;
          display: -ms-flexbox;
          display: flex; }

      .bootstrap.ng2-tag-input {
        display: block;
        -webkit-box-orient: horizontal;
        -webkit-box-direction: normal;
            -ms-flex-direction: row;
                flex-direction: row;
        -ms-flex-wrap: wrap;
            flex-wrap: wrap;
        position: relative;
        cursor: text;
        border-bottom: 2px solid #efefef; }
        .bootstrap.ng2-tag-input:focus {
          outline: 0; }
        .bootstrap.ng2-tag-input.ng2-tag-input--dropping {
          opacity: 0.7; }
        .bootstrap.ng2-tag-input.ng2-tag-input--focused {
          border-bottom: 2px solid #0275d8; }
        .bootstrap.ng2-tag-input.ng2-tag-input--invalid {
          border-bottom: 2px solid #d9534f; }
        .bootstrap.ng2-tag-input.ng2-tag-input--loading {
          border: none; }
        .bootstrap.ng2-tag-input.ng2-tag-input--disabled {
          opacity: 0.5;
          cursor: not-allowed; }
        .bootstrap.ng2-tag-input .ng2-tags-container {
          -ms-flex-wrap: wrap;
              flex-wrap: wrap;
          display: -webkit-box;
          display: -ms-flexbox;
          display: flex; }

      .bootstrap3-info.ng2-tag-input {
        display: block;
        -webkit-box-orient: horizontal;
        -webkit-box-direction: normal;
            -ms-flex-direction: row;
                flex-direction: row;
        -ms-flex-wrap: wrap;
            flex-wrap: wrap;
        position: relative;
        padding: 4px;
        cursor: text;
        -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
                box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
        border-radius: 4px; }
        .bootstrap3-info.ng2-tag-input:focus {
          outline: 0; }
        .bootstrap3-info.ng2-tag-input.ng2-tag-input--dropping {
          opacity: 0.7; }
        .bootstrap3-info.ng2-tag-input.ng2-tag-input--invalid {
          border-bottom: 1px solid #d9534f; }
        .bootstrap3-info.ng2-tag-input.ng2-tag-input--loading {
          border: none; }
        .bootstrap3-info.ng2-tag-input.ng2-tag-input--disabled {
          opacity: 0.5;
          cursor: not-allowed; }
        .bootstrap3-info.ng2-tag-input form {
          margin: 0.1em 0; }
        .bootstrap3-info.ng2-tag-input .ng2-tags-container {
          -ms-flex-wrap: wrap;
              flex-wrap: wrap;
          display: -webkit-box;
          display: -ms-flexbox;
          display: flex; }

      .error-message {
        font-size: 0.8em;
        color: #f44336;
        margin: 0.5em 0 0 0; }

      .bootstrap .error-message {
        color: #d9534f; }

      .ng2-tag-input__text-input {
        display: inline;
        vertical-align: middle;
        border: none;
        padding: 0 0.5rem;
        height: 38px;
        font-size: 1em;
        font-family: "Roboto", "Helvetica Neue", sans-serif; }
        .ng2-tag-input__text-input:focus {
          outline: 0; }
        .ng2-tag-input__text-input[disabled=true] {
          opacity: 0.5;
          background: #fff; }
    `],
    template: `
      <!-- form -->
      <form (submit)="submit($event)" [formGroup]="form">
          <input #input

                 type="text"
                 class="ng2-tag-input__text-input"
                 autocomplete="off"
                 tabindex="{{ disabled ? -1 : tabindex ? tabindex : 0 }}"
                 minlength="1"

                 [(ngModel)]="inputText"
                 [formControlName]="'item'"
                 [ngClass]="inputClass"
                 [attr.id]="inputId"
                 [attr.placeholder]="placeholder"
                 [attr.aria-label]="placeholder"
                 [attr.tabindex]="tabindex"
                 [attr.disabled]="disabled ? disabled : null"

                 (focus)="onFocus.emit($event)"
                 (blur)="onBlur.emit($event)"
                 (keydown)="onKeyDown($event)"
                 (keyup)="onKeyup.emit($event)"
          />
      </form>
    `
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'onSubmit': [{ type: Output },],
'onBlur': [{ type: Output },],
'onFocus': [{ type: Output },],
'onKeyup': [{ type: Output },],
'onKeydown': [{ type: Output },],
'placeholder': [{ type: Input },],
'validators': [{ type: Input },],
'asyncValidators': [{ type: Input },],
'inputId': [{ type: Input },],
'inputClass': [{ type: Input },],
'inputText': [{ type: Input },],
'tabindex': [{ type: Input },],
'disabled': [{ type: Input },],
'input': [{ type: ViewChild, args: ['input', ] },],
'inputTextChange': [{ type: Output },],
};
}

function TagInputForm_tsickle_Closure_declarations() {
/** @type {?} */
TagInputForm.decorators;
/**
 * @nocollapse
 * @type {?}
 */
TagInputForm.ctorParameters;
/** @type {?} */
TagInputForm.propDecorators;
/**
 * \@name onSubmit
 * @type {?}
 */
TagInputForm.prototype.onSubmit;
/**
 * \@name onBlur
 * @type {?}
 */
TagInputForm.prototype.onBlur;
/**
 * \@name onFocus
 * @type {?}
 */
TagInputForm.prototype.onFocus;
/**
 * \@name onKeyup
 * @type {?}
 */
TagInputForm.prototype.onKeyup;
/**
 * \@name onKeydown
 * @type {?}
 */
TagInputForm.prototype.onKeydown;
/**
 * \@name placeholder
 * @type {?}
 */
TagInputForm.prototype.placeholder;
/**
 * \@name validators
 * @type {?}
 */
TagInputForm.prototype.validators;
/**
 * \@name asyncValidators
 * @desc array of AsyncValidator that are used to validate the tag before it gets appended to the list
 * @type {?}
 */
TagInputForm.prototype.asyncValidators;
/**
 * \@name inputId
 * @type {?}
 */
TagInputForm.prototype.inputId;
/**
 * \@name inputClass
 * @type {?}
 */
TagInputForm.prototype.inputClass;
/**
 * \@name tabindex
 * @desc pass through the specified tabindex to the input
 * @type {?}
 */
TagInputForm.prototype.tabindex;
/**
 * \@name disabled
 * @type {?}
 */
TagInputForm.prototype.disabled;
/**
 * \@name input
 * @type {?}
 */
TagInputForm.prototype.input;
/**
 * \@name form
 * @type {?}
 */
TagInputForm.prototype.form;
/**
 * \@name inputTextChange
 * @type {?}
 */
TagInputForm.prototype.inputTextChange;
/**
 * \@name inputTextValue
 * @type {?}
 */
TagInputForm.prototype.inputTextValue;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
